export const privacyData = [
    'Контролёр обработки данных',
    'Настоящая политика конфиденциальности относится к обработке персональных данных, собранных через веб-сайт 22Archetypes, принадлежащий Ольге Кузьменко (далее "Контролёр"), с операционным офисом по адресу Corso degli Inglesi 462, 18038, Санремо (Италия).',
    'Цели обработки',
    'Персональные данные, собранные через форму запроса консультации, будут обрабатываться для следующих целей:',
    'Предоставление ответов на запросы консультации;',
    'Связь с пользователем для назначения встреч и предоставления информации о запрошенных услугах;',
    'Выполнение любых юридических обязательств;',
    'Улучшение пользовательского опыта на веб-сайте.',
    'Правовая основа обработки',
    'Обработка данных основана на явном согласии пользователя, предоставленном путём заполнения и отправки формы запроса консультации.',
    'Тип собираемых данных',
    'Собираемые персональные данные включают, но не ограничиваются:',
    'Имя и фамилия;',
    'Адрес электронной почты;',
    'Номер телефона;',
    'Любая дополнительная информация, добавленная добровольно в форму запроса.',
    'Способ обработки и хранения данных',
    'Данные будут обрабатываться в соответствии с действующими нормами о защите персональных данных...',
    'Раскрытие и передача данных',
    'Персональные данные не будут передаваться третьим лицам без явного согласия пользователя...',
    'Права субъекта данных',
    'Пользователи имеют право на: доступ к своим персональным данным и запрос копии; запрос исправления; запрос удаления; отзыв согласия; возражение против обработки; запрос ограничения обработки.',
    'Для реализации этих прав пользователь может связаться с Контролёром по адресу электронной почты: 22archetypes@gmail.com.',
    'Изменения в политике конфиденциальности',
    'Контролёр оставляет за собой право вносить изменения в настоящую политику...',
    'Контакты',
    'По любым вопросам относительно настоящей политики или обработки персональных данных вы можете связаться с Ольгой Кузьменко по адресу электронной почты 22archetypes@gmail.com.',
    'Последнее обновление: 10.02.2025.',
];
